const STYLES = {
  S1: { bg: "bg-yellow-400/15", text: "text-yellow-400", border: "border-yellow-400/40", label: "S1 · Recruit" },
  S3: { bg: "bg-teal-400/15", text: "text-teal-400", border: "border-teal-400/40", label: "S3 · Operator" },
  S5: { bg: "bg-purple-400/15", text: "text-purple-400", border: "border-purple-400/40", label: "S5 · Inner Circle" },
};

export const CREW_LEVEL_OPTIONS = [
  { id: "S1", label: "S1 · Recruit" },
  { id: "S3", label: "S3 · Operator" },
  { id: "S5", label: "S5 · Inner Circle" },
];

/** Compact colored pill identifying a crew member's tier. */
export function LevelBadge({ level, size = "sm", showLabel = true, className = "" }) {
  const s = STYLES[level] || STYLES.S1;
  const sizeCls = size === "lg" ? "px-3 py-1.5 text-xs" : size === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]";
  return (
    <span data-testid={`level-badge-${level || "S1"}`}
      className={`inline-flex items-center gap-1.5 rounded-full border font-mono-cc font-bold uppercase tracking-wider ${s.bg} ${s.text} ${s.border} ${sizeCls} ${className}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.text.replace("text-", "bg-")}`} />
      {showLabel ? s.label : level}
    </span>
  );
}
